module.exports = __webpack_public_path__ + "img/application-rej-back.14d41190.svg";